export const environment = {
  production: true,
  buildTarget: 'web', // 'web' | 'extension'
  apiUrl: '',
  web: 'https://uat.rubiz.io',
  stripeKey: '',
  tgBot: '',
  vapidKey: '',
  frontDomain: 'front.uat.rubiz.io',
  firebase: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
};
